import React from 'react';
import { useNavigate } from 'react-router-dom';
import { stringToColor, readableTextColor } from '../utils/color';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleString();
}

function IdeaCard({ idea, onOpen }) {
  const navigate = useNavigate();
  return (
    <article className="panel card" style={{ padding: 16 }} onClick={() => navigate(`/idea/${idea.id}`)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate(`/idea/${idea.id}`); }}>
      <div className="card-body grid gap-2">
        <header className="grid" style={{ gap: 6 }}>
          <h3 style={{ margin: 0 }}>{idea.title || 'Untitled idea'}</h3>
          {(idea.category?.name || idea.master_category) && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {idea.category?.name && (() => {
                const bg = stringToColor(idea.category.name);
                const color = readableTextColor(bg);
                return <span className="chip chip--clickable" onClick={(e) => { e.stopPropagation(); onOpen?.({ ...idea, __chipCategory: idea.category.name, __chipMaster: idea.master_category }); }} style={{ background: bg, color }}>{idea.category.name}</span>;
              })()}
              {idea.master_category && (() => {
                const bg = stringToColor(idea.master_category);
                const color = readableTextColor(bg);
                return <span className="chip chip--clickable" onClick={(e) => { e.stopPropagation(); onOpen?.({ ...idea, __chipMaster: idea.master_category }); }} style={{ background: bg, color }}>{idea.master_category}</span>;
              })()}
            </div>
          )}
        </header>
        {idea.description && <p>{idea.description}</p>}
        <div className="card-footer">
          {typeof idea.score === 'number' && (
            <span className="badge badge--score" title="Score"><i className="fa-solid fa-heart" style={{ marginRight: 6 }} />{idea.score}</span>
          )}
        </div>
      </div>
    </article>
  );
}

export default IdeaCard;


